import { observer } from 'mobx-react-lite';
import { Button, Modal } from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import DynamicTableFrontEnd from '../../../DynamicTable/DynamicTableFrontEnd';

function Movementiview() {
  const { activityStore } = useStore();
  const { movementtracker } = activityStore;

  const removeCol = 'title,type';
  const assettable = JSON.parse(JSON.stringify(movementtracker));
  assettable?.map(
    (i: any) =>
      delete i.month &&
      delete i.days &&
      delete i.hours &&
      delete i.sec &&
      delete i.mins &&
      delete i.itemId,
  );

  assettable?.map((i: any) => removeCol.split(',').map((j) => delete i[j]));
  return (
    <Modal
      style={{ width: '930px' }}
      onClose={() => activityStore.setopenviewmodel(false)}
      onOpen={() => activityStore.setopenviewmodel(true)}
      open={activityStore.setOpenmovementview}
      className="momentview-modal"
    >
      <Modal.Header>View</Modal.Header>
      <DynamicTableFrontEnd
        data={assettable}
        name={'Movementview'}
        actiontype={''}
      />
      <Modal.Content></Modal.Content>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => activityStore.setopenviewmodel(false)}
        >
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
export default observer(Movementiview);
